import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=3979c6d1&scoped=true"
import script from "./Issues.vue?vue&type=script&lang=ts"
export * from "./Issues.vue?vue&type=script&lang=ts"
import style0 from "./Issues.vue?vue&type=style&index=0&id=3979c6d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3979c6d1",
  null
  
)

export default component.exports